import React, { Fragment } from 'react';
import { useLocalizedStrings } from 'app/localization/Context';

import { ReactComponent as IconThreeDotsLoadingDark } from 'images/general/three-dots-loading-dark.svg';

import { ReactComponent as IconDoorbellOff } from 'images/device/status-icon/doorbell-off.svg';
import { ReactComponent as IconDoorbellBlack } from 'images/device/status-icon/doorbell-black.svg';
import { ReactComponent as IconDoorbellHinavaSymbol } from 'images/device/symbol/hinava_gradient/doorbell.svg';


import './All.scss'


export default function DoorbellControl({ device, darkerBorder }) {
    const s = useLocalizedStrings();

    const containerClass = device.active ?
        "device-detail-control with-flex active" : "device-detail-control with-flex inactive";

    return (
        <Fragment>
            <div className={containerClass}>
                <div className={"doorbell-control-box" + (darkerBorder ? " darker" : "")}>
                    <DoorbellSingleButton s={s} showStates={true}
                        onClickH={() => { device.changeState({ state: true }) }} />

                    {device.state ? <DoorbellStatePanel s={s}
                        onClickH={() => { device.changeState({ state: false }) }}
                        waitingForChangeState={device.waitingForChangeState["state"]} /> : null}
                </div>
            </div>
        </Fragment>

    )
}

export function DoorbellSingleButton({ onClickH, s, showStates }) {
    if (!showStates) {
        return (
            <div className="device-button"
                style={{ width: 65 }}> {/* set width > label's length, for better placement of buttons and not changing on state changes*/}
                <IconDoorbellHinavaSymbol className="icon" />
                <div className="status-placeholder" />
            </div>
        );
    } else {
        return (
            <div className="device-button"
                style={{ width: 65 }}> {/* set width > label's length, for better placement of buttons and not changing on state changes*/}
                <IconDoorbellOff className="device-button-icon-off" />
                <div className="device-off-label status-text-or-icon">{s.off}</div>
                <div className="device-on-click-overlay" onClick={onClickH} />
            </div>
        );
    }
}

export function DoorbellStatePanel({ waitingForChangeState, s, forDeviceList, onClickH }) {
    const shouldShowWaiting = forDeviceList && waitingForChangeState && !waitingForChangeState.ignoreWaiting;

    return (
        <div className={"doorbell-panel full"} onClick={onClickH} >
            <IconDoorbellBlack className="icon" />

            <div className="label">{s.doorbell.ringing}</div>

            {
                !shouldShowWaiting ?
                    (forDeviceList ? <div className="info">{s.doorbell.tapToStop}</div> : null)
                    : <IconThreeDotsLoadingDark className="curtain-dots-icon" />
            }
        </div>
    );
}